import { createStyles } from '@/styles/theme/utils';

export const resetPasswordStyles = createStyles({
   company_area: {
      bg: 'black',
      py: '10',
   },
   container: {
      px: '12',
   },
   reset_area: {
      display: 'flex',
      justifyContent: 'center',
      py: '24',
   },
   reset_box: {
      w: '410px',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '20px',
   },
   reset_form: {
      width: '100%',
   },
});
